/* eslint-disable no-magic-numbers */

import * as types from '../../../../store/mutation-types';
import UploadPhoto from '../../../upload-photo/upload-photo.vue';

export default {
  components: { UploadPhoto },
  data() {
    return {
      uploadStatus: false,
      form: {},
      uploadError: [],
      submittingPurchaseInfo: false,
    };
  },
  methods: {
    submitPic() {
      this.$validator
        .validateAll()
        .then(() => {
          this.submittingPurchaseInfo = true;
          Promise.all([this.$store.dispatch('updatePicInformation', this.form)]).then(() => {
            this.submittingPurchaseInfo = false;
          });
        })
        .then(() => { this.$store.commit(types.CLEAR_CART); })
        .catch(err => {
          console.log(err);
        });
    },
    uploadDone() {
      this.uploadStatus = 'uploaded';
    },
    checkAndEnableUpload(selectedFile) {
      if (selectedFile.errors.length) {
        this.uploadError = selectedFile.errors;
      } else {
        this.uploadStatus = 'ready';
        this.uploadError = [];
      }
    },
  },
};
